import { Capacitor } from '@capacitor/core';
import { TokenService } from './tokenService';
import { BrowserStrategy } from './strategies/browserStrategy';
import { CapacitorStrategy } from './strategies/capacitorStrategy';
import type { CookieConfig } from './tokenContracts';

let instance: TokenService | null = null;

export async function createTokenService(topDomain: string): Promise<TokenService> {
  const isNative = Capacitor.isNativePlatform();
  const isProd = import.meta.env.PROD;

  const config: CookieConfig = {
    accessTokenName: 'Bearer',
    refreshTokenName: 'RefreshToken',
    domain: isNative ? '' : topDomain,
    path: '/',
    // `isProd` (import.meta.env.PROD) is true for every `vite build`
    // (sandbox/staging/production — all served over HTTPS) and false only for
    // local `vite dev` on http://localhost, where a Secure cookie wouldn't be
    // stored at all. So auth cookies are Secure everywhere except local dev,
    // which is intentional.
    secure: isProd,
    sameSite: 'Lax'
  };

  if (isNative) {
    const strategy = new CapacitorStrategy();
    await strategy.initialize(config);
    instance = new TokenService(config, strategy);
  } else {
    instance = new TokenService(config, new BrowserStrategy());
  }

  return instance;
}

export function getTokenService(): TokenService {
  if (!instance) {
    throw new Error('TokenService not initialized. Call createTokenService() first.');
  }
  return instance;
}
